import script from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=297a54fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297a54fa"]])

export default __exports__